import { Button } from 'antd';
import { useTranslation } from 'react-i18next';
import Icons from '../../../../configs/icon.config';

interface DrawerFooterProps {
  handleSkip: any;
  onSubmit: any;
  updateLoading: boolean;
}

function DrawerFooter({
  handleSkip,
  onSubmit,
  updateLoading,
}: DrawerFooterProps) {
  const { t } = useTranslation();
  return (
    <div>
      <div className="p-4 flex justify-around">
        <Button
          className="h-[35px] border-[#D10D74] flex items-center py-1 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-md hover:border-[#D10D74]"
          style={{ borderRadius: 0 }}
          onClick={handleSkip}
        >
          <div className="flex gap-4 justify-center items-center p-2.5 lg:px-5 md:px-10">
            <div className="text-[15px] text-[#D10D74]">
              {Icons.skipForward}
            </div>
            <div className="text-xl font-extrabold text-[#D10D74]">
              {t('feedback.skip')}
            </div>
          </div>
        </Button>
        <Button
          className="bg-[#D10D74] h-[35px] flex items-center py-2 cursor-pointer hover:scale-[1.03] transition-all hover:shadow-md hover:shadow-white hover:border-none"
          style={{ borderRadius: 0 }}
          onClick={onSubmit}
          loading={updateLoading}
        >
          <div className="flex gap-4 justify-center items-center p-5 lg:px-5 md:px-10">
            <div className="text-[15px] text-white">{Icons.upload}</div>
            <div className="text-xl font-extrabold text-white">
              {' '}
              {t('feedback.submit')}
            </div>
          </div>
        </Button>
      </div>
    </div>
  );
}

export default DrawerFooter;
